import * as React from 'react';
import { styles } from './styles';
import { BaseButton } from '@routes/event/create/components/BaseButton';
import { DesignSection } from '@routes/event/create/DesignDemo/types';

interface Props {
  section: DesignSection;
  onResetClick: React.MouseEventHandler<HTMLElement>;
}

export const SelectionResetButton: React.SFC<Props> = ({ onResetClick, section }) => {
  return (
    <BaseButton type="button" data-section={section} onClick={onResetClick}>
      <span className={styles.container}>Show All</span>
    </BaseButton>
  );
};
